import { useAllZoneList } from "../../../assets/api/useMarketingExecutive";
import useAuthStore from "../../../store/useAuthStore";

export const useZoneOptions = (filters) => {
    const { user } = useAuthStore();

    const { data: addedZoneList, isLoading: isLoadingaddedZoneList } =
        useAllZoneList(filters);

    const zoneList = addedZoneList?.data || [];

    const role = user?.role;

    const isMarketingManager = role === "Marketing Manager";
    const isClusterFilterRole =
        role === "Marketing Executive" || role === "Zonal Coordinator";

    let filteredList = zoneList;

    /** ------------------------------------
     * 1️⃣ FILTER BY ZONE IDs (Zone-wise)
     * Roles: Marketing Executive, Zonal Coordinator
     * ------------------------------------ */
    if (isClusterFilterRole) {
        const userZoneIds = user?.zones?.map((z) => z.id) || [];
        filteredList = zoneList?.filter((zone) =>
            userZoneIds?.includes(zone?.zone_id)
        );
    }

    /** ------------------------------------
     * 2️⃣ FILTER BY CITY NAME (Marketing Manager)
     * ------------------------------------ */
    if (isMarketingManager) {
        const userCityName = user?.city?.toLowerCase();
        filteredList = zoneList.filter(
            (zone) =>
                zone?.city_name?.toLowerCase() === userCityName
        );
    }

    /** ------------------------------------
     * 3️⃣ MAP FOR AUTO-COMPLETE OPTIONS
     * ------------------------------------ */
    const AddedZoneOption = filteredList.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        label: item.zone_name,
        value: item.zone_name,
        ...item,
    }));

    return {
        AddedZoneOptions: {
            options: AddedZoneOption,
            isLoading: isLoadingaddedZoneList,
        },
    };
};
